export default "__VITE_ASSET__d2a1e9ff__"